import React from 'react';

import { SaveButton } from '../../../common/button/save-button/SaveButton';

import './UsersView.css';

export const UserViewGeneralTab = ({ user, navigateBack, handleNavigationClick }) => {
  const handleBackClick = () => {
    navigateBack();
  };

  const handleNextClick = () => {
    handleNavigationClick('userRolesAndPermissions');
  };

  return (
    <div className="tab-container">
      <div className="form-section-left">
        <div className="input-container" style={{ padding: '10px' }}>
          <label className={'admin-label-general'}>First Name:</label>
          <label className={'input-label-admin-general'}>{user.firstName}</label>
        </div>
        <div className="input-container" style={{ padding: '10px' }}>
          <label className={'admin-label-general'}>Last Name:</label>
          <label className={'input-label-admin-general'}>{user.lastName}</label>
        </div>
        <div className="input-container" style={{ padding: '10px' }}>
          <label className={'admin-label-general'}>Username:</label>
          <label className={'input-label-admin-general'}>{user.userName}</label>
        </div>
        <div className="input-container" style={{ padding: '10px' }}>
          <label className={'admin-label-general'}>Email Address:</label>
          <label className={'input-label-admin-general'}>{user.emailAddress}</label>
        </div>
        <div className="input-container" style={{ padding: '10px' }}>
          <label className={'admin-label-general'}>Cellphone Number:</label>
          <label className={'input-label-admin-general'}>{user.cellphoneNumber}</label>
        </div>
      </div>

      <div className="user-view-buttons">
        <SaveButton
          color={'#ffffff'}
          textColor={'#077187'}
          border={'1px solid #077187'}
          title={'Back'}
          onClick={handleBackClick}
        />
        <SaveButton color={'#077187'} title={'Next'} onClick={handleNextClick} />
      </div>
    </div>
  );
};
